import React from 'react';

export default function BuilderPane({ children }) {
    // Don’t add scroll/transform here; keep Field’s layout stable
    return <div className="qr-builder">{children}</div>;
}
